<template>
  <div v-if="author" class="flex flex-col items-center font-roboto sm:flex-row">
    <div
      class="relative z-[1] h-full max-h-[160px] min-h-[160px] min-w-[160px] max-w-[160px] overflow-hidden rounded-50% bg-white-100 p-[8px] shadow-drop-2 sm:mr-6 xl:mr-9 xl:max-h-[232px] xl:min-h-[232px] xl:min-w-[232px] xl:max-w-[232px]"
    >
      <div class="size-full overflow-hidden rounded-50%">
        <img
          v-lazy-load
          :src="getSrc"
          :alt="
            author.image && author.image.alt
              ? author.image.alt
              : author.fullname
          "
          class="size-full object-cover"
        />
      </div>
    </div>
    <div
      class="relative z-0 mt-[-80px] flex w-fill flex-col items-center justify-between rounded-[12px] px-4 pb-6 pt-[100px] shadow-drop-2 sm:ml-[-96px] sm:mt-[initial] sm:flex-row sm:py-[28px] sm:pl-[94px] sm:pr-[28px] xl:ml-[-120px] xl:pl-[120px] 2xl:py-[49px] 2xl:pr-[76px]"
    >
      <div class="flex flex-col text-center sm:text-left">
        <h3
          class="mb-[8px] text-[14px] font-semibold uppercase leading-[18px] text-collection xl:text-[20px] xl:leading-[26px]"
          v-text="author.fullname"
        />
        <div
          class="max-h-[48px] font-medium"
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          "
          v-html="author.announce || author.description"
        ></div>
      </div>
      <NuxtLink
        class="mt-5 block whitespace-nowrap rounded-[8px] border-[1.75px] border-collection px-[24px] py-[16px] text-[12px] font-medium uppercase text-collection sm:ml-4 sm:mt-[initial] 2xl:px-[32px] 2xl:py-[20px] 2xl:text-[18px] 2xl:leading-[22px]"
        :to="`/authors/${author.slug}`"
        >Работы автора</NuxtLink
      >
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  author: {
    type: Object,
    default: () => ({}),
  },
});

const getSrc = computed(() => {
  const src =
    props.author?.image && props.author.image?.src
      ? props.author.image.src
      : null;

  if (!src) return '/imgs/default-image.png';
  return src;
});
</script>
